import React, { createContext, useContext, useState } from 'react';

const HeaderContext = createContext();

export const HeaderProvider = ({ children }) => {
  const [showHeader, setShowHeader] = useState(() => {
    const stored = localStorage.getItem('showHeader');
    return stored === null ? true : JSON.parse(stored);
  });

  const hideHeader = () => {
    setShowHeader(false);
    localStorage.setItem('showHeader', 'false');
  };

  return (
    <HeaderContext.Provider value={{ showHeader, hideHeader }}>
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeader = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error('useHeader must be used within a HeaderProvider');
  }
  return context;
};
